import { JourneyCardsContainer } from './styles';
import StepCard from '../StepCard';
import { StepCardBackground } from '../StepCard/styles';

const JourneyCards = ({ steps }) => {
  return (
    <JourneyCardsContainer>
      {steps.map((step, index) => (
        <StepCardBackground key={step.id} accent={index % 2 === 0 ? 'top' : 'bottom'}>
          <StepCard
            key={step.id}
            id={step.id}
            titleTop={step.titleTop}
            titleBottom={step.titleBottom}
            layout={step.layout}
            accent={index % 2 === 0 ? 'top' : 'bottom'}
          />
        </StepCardBackground>
      ))}
    </JourneyCardsContainer>
  );
};

export default JourneyCards;
